/**
 * @desc availableReconFiles
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(params: API.walmart.test.availableReconFiles.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/availableReconFiles`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
